export function getApiBaseUrl() {
  const rawBaseURL = import.meta.env.VITE_API_URL
  if (!rawBaseURL) return '/api'
  const trimmed = `${rawBaseURL}`.replace(/\/+$/, '')
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`
}

/**
 * Opens an SSE connection using a short-lived stream token when available.
 * Returns the EventSource and a disconnect function.
 */
export async function openEventStream({ authToken }) {
  if (!authToken) return { es: null, disconnect: () => {} }

  const base = getApiBaseUrl()
  let streamToken = authToken

  try {
    const res = await fetch(`${base}/events/stream-token`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${authToken}`, 'Content-Type': 'application/json' }
    })
    if (res.ok) {
      const json = await res.json()
      if (json?.token) streamToken = json.token
    }
  } catch (_) {}

  const streamUrl = `${base}/events/stream?token=${encodeURIComponent(streamToken)}`
  const es = new EventSource(streamUrl)

  return {
    es,
    disconnect: () => {
      try {
        es.close()
      } catch (_) {}
    }
  }
}
